import { styled } from '@ori-ui/mui';
import { useToken } from '@ori/auth';
import type { FC } from 'react';

import { useAppConfig } from '../context';
import { FavoritesHeartIcon } from './FavoritesHeartIcon';
import { JoinIcon } from './Join/JoinIcon';
import { NotificationBellIcon } from './NotificationBellIcon';
import { SearchIcon } from './SearchIcon';
import { SearchInput } from './SearchInput';
import { ShoppingBagIcon } from './ShoppingBagIcon/ShoppingBagIcon';
import { UserSection } from './UserSection';

const RightActionsSectionRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(3),
  justifySelf: 'end',
  justifyContent: 'flex-end',
  marginLeft: theme.spacing(3),
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'end',
  },

  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
    marginLeft: theme.spacing(4),
    maxWidth: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(8),
    marginLeft: theme.spacing(8),
  },
}));

export const RightActionsSection: FC = () => {
  const { isAnonymousUser } = useToken();
  const { shouldDisplayNotificationIcon } = useAppConfig();
  const showFavorites = !isAnonymousUser;
  const showNotifications = !isAnonymousUser && shouldDisplayNotificationIcon;

  return (
    <RightActionsSectionRoot>
      <SearchInput showOnlyOn="desktop" />
      <SearchIcon />
      {isAnonymousUser ? <JoinIcon /> : null}
      <UserSection />
      {showNotifications ? <NotificationBellIcon /> : null}
      {showFavorites ? <FavoritesHeartIcon /> : null}
      <ShoppingBagIcon />
    </RightActionsSectionRoot>
  );
};
